import React from 'react';
export const ComparisonTable = () => {
  // For mobile view, we'll use a different structure
  const comparisons = [{
    traditional: '$100-$200 per session',
    elivara: 'One-time investment (currently 40% off for first-time customers)'
  }, {
    traditional: 'Relief lasts hours to a few days',
    elivara: 'Continuous support throughout the day'
  }, {
    traditional: 'Recurring appointments required indefinitely',
    elivara: 'No recurring appointments needed'
  }, {
    traditional: 'Annual costs: $2,400 to $10,000+',
    elivara: 'Sustained use with one purchase'
  }, {
    traditional: 'Manually moves fluid periodically',
    elivara: 'Provides constant graduated pressure following lymphatic pathways'
  }, {
    traditional: 'Requires scheduling and travel',
    elivara: 'Wear at home, work, anywhere'
  }, {
    traditional: 'Dependent on therapist availability',
    elivara: 'Available whenever you need it'
  }, {
    traditional: 'Temporary intervention, then system returns to baseline',
    elivara: 'Continuous mechanical support all day'
  }];
  return <>
      {/* Desktop table */}
      <div className="hidden sm:block overflow-x-auto" data-id="element-170">
        <table className="w-full border-collapse" data-id="element-171">
          <thead data-id="element-172">
            <tr data-id="element-173">
              <th className="border p-3 bg-gray-100 text-left" data-id="element-174">
                Professional Manual Treatments:
              </th>
              <th className="border p-3 bg-pink-100 text-left" data-id="element-175">
                Elivara FlowMapping™ Compression:
              </th>
            </tr>
          </thead>
          <tbody data-id="element-176">
            {comparisons.map((item, index) => <tr key={index} data-id="element-177">
                <td className="border p-3" data-id="element-178">{item.traditional}</td>
                <td className="border p-3" data-id="element-179">{item.elivara}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Mobile comparison cards */}
      <div className="sm:hidden space-y-4" data-id="element-180">
        {comparisons.map((item, index) => <div key={index} className="border rounded-md overflow-hidden" data-id="element-181">
            <div className="bg-gray-100 p-3 font-medium text-sm" data-id="element-182">
              Professional Manual Treatments:
            </div>
            <div className="p-3 border-b text-sm" data-id="element-183">{item.traditional}</div>
            <div className="bg-pink-100 p-3 font-medium text-sm" data-id="element-184">
              Elivara FlowMapping™:
            </div>
            <div className="p-3 text-sm" data-id="element-185">{item.elivara}</div>
          </div>)}
      </div>
    </>;
};